"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.flatten = exports.intoObj = exports.log = exports.mergeObjects = exports.forEach = exports.find = exports.some = exports.reduce = exports.map = exports.filter = exports.pipe = exports.objToArr = void 0;
const reporter_1 = __importDefault(require("../../reporter"));
const objToArr = obj => Reflect.ownKeys(obj).map(k => [k, obj[k]]);
exports.objToArr = objToArr;
const pipe = data => (...fns) => fns.reduce((acc, fn) => (typeof fn === 'function' ? fn(acc) : acc), data);
exports.pipe = pipe;
exports.pipe.async = data => (...fns) => fns.reduce((acc, fn) => acc.then(fn), Promise.resolve(data));
exports.pipe.objToArr = data => (0, exports.pipe)(data)(exports.objToArr, exports.pipe);
exports.pipe.async.objToArr = data => (0, exports.pipe)(data)(exports.objToArr, exports.pipe.async);
const asyncify = fnToAsync => fn => arr => Promise.all((0, exports.pipe)(arr)(fnToAsync(fn)));
const filter = fn => arr => arr.filter(fn);
exports.filter = filter;
const map = fn => arr => arr.map(fn);
exports.map = map;
const reduce = (fn, acc) => arr => arr.reduce(fn, acc);
exports.reduce = reduce;
const some = fn => arr => arr.some(fn);
exports.some = some;
const find = fn => arr => arr.find(fn);
exports.find = find;
const forEach = fn => arr => arr.forEach(fn);
exports.forEach = forEach;
[exports.map, exports.filter, exports.reduce, exports.some, exports.find].forEach(fn => {
    fn.async = asyncify(fn);
});
// accepts an array of objects and merges them together.
// mergeObjects([{foo: 'bar'}, {baz: 'bat'}])
// > { foo: 'bar', baz: 'bat' }
const mergeObjects = arr => arr.length === 0 ? {} : Object.assign({}, ...arr);
exports.mergeObjects = mergeObjects;
const log = tag => data => {
    reporter_1.default.log(`${tag}: <${typeof data}>`, data);
    return data;
};
exports.log = log;
// TODO: Test which implementation below is faster
const intoObj = data => (0, exports.pipe)(data)((0, exports.map)(([k, v]) => ({ [k]: v })), exports.mergeObjects);
exports.intoObj = intoObj;
// pipe(data)(reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {}));
exports.flatten = (0, exports.reduce)((acc, arr) => acc.concat(arr), []);
//# sourceMappingURL=index.js.map